
import { createAsyncThunk, isRejectedWithValue } from "@reduxjs/toolkit";
import ApiBuilder, { WriteReviewInterface } from "@/api/ApiBuilder";
import { Values } from "@/constants/Values";
// import { VenuesPageProps } from "@/types/interfaceType";


interface updateprofileArgs {
    data: any; // Replace `any` with a proper interface if available
    callback?: (response: any) => void; // Optional callback
}


interface getdefaultArgs {
    queryParams?:{
        page:number,limit:number
    };
    pathparams?: String;
    callback?: (response: any) => void; // Optional callback
}

interface getBoookingArgs {
    queryParams?:{
        page:number,limit:number,status:string,dbl_subscriptionid?:string
        bookingId?:string, refId?:string, date?:string

    };
    page?:number;
    pathparams?: String;
    callback?: (response: any) => void; // Optional callback
}

interface writeReviewProps {
    data: WriteReviewInterface,
    callback?: (response: any) => void; // Optional callback
}

interface wishlistProps{
    data: {venueId:string},
    callback?: (response: any) => void; // Optional callback
}
interface ReviewsArgs {
    pathparams?: string;
    page?:number;
    queryParams?: { page: number, limit: number };
    callback?: (response: any) => void; // Optional callback
}


interface UserRecommendationArgs {
    payload?: {lat:Number,lng:Number,city?:String};
    callback?: (response: any) => void; // Optional callback
}


export const getProfile = createAsyncThunk(
    "user/getProfile",
    async (callback: any, { rejectWithValue }) => {
        try {
            const response = await ApiBuilder.getProfile();
            if (callback) {
                callback(response)
            }
            return response;
        } catch (error) {
            const errorMessage =
                error?.error || error?.response?.data?.message || error?.message || "Login failed";
            return rejectWithValue(errorMessage);
        }
    }
);

export const getProfileV2 = createAsyncThunk<any, {token:string,callback?: (response: any) => void}>(
    "user/getProfileV2",
        async ({ token, callback }, { rejectWithValue }) => {
        try {
            const response = await ApiBuilder.getProfileV2(token);
            if (callback) {
                callback(response)
            }
            return response;
        } catch (error) {
            const errorMessage =
                error?.error || error?.response?.data?.message || error?.message || "Login failed";
            return rejectWithValue(errorMessage);
        }
    }
);


export const updateUserProfile = createAsyncThunk<any, updateprofileArgs>(
    "user/updateUserProfile",
    async ({ data, callback }, { rejectWithValue }) => {
        try {
            const response = await ApiBuilder.updateUserProfile(data);
            if (callback) {
                callback(response)
            }
            return response;
        } catch (error) {
            const errorInput = error?.errorInput || null
            const errorMessage =
                error?.error || error?.response?.data?.message || error?.message || "Update failed";
                if (callback) {
                    callback(error)
                }
            return rejectWithValue({errorMessage,errorInput});
        }
    }
);

export const getMyBookings = createAsyncThunk<any, getBoookingArgs>(
    "user/getMyBookings",
    async ({ queryParams,callback }, { rejectWithValue }) => {
        try {
            const response = await ApiBuilder.getMyBookings(queryParams);
            if (callback) {
                callback(response)
            }
            return response;
        } catch (error) {
            const errorMessage =
                error?.error || error?.response?.data?.message || error?.message || "Update failed";
            return rejectWithValue(errorMessage);
        }
    }
);

export const getmyBookingsWithPagination = createAsyncThunk<any, getBoookingArgs>(
    "user/getmyBookingsWithPagination",
    async ({ queryParams ={page:1,limit:Values.myBookingLimit,status:null},page,callback }, { rejectWithValue }) => {
        try {
            const response = await ApiBuilder.getmyBookingsWithPagination(queryParams);
            if (callback) {
                callback(response)
            }
            return response;
        } catch (error:any) {
            const errorMessage =
                error?.error || error?.response?.data?.message || error?.message || "My Booking fetch failed";
            return rejectWithValue(errorMessage);
        }
    }
);

export const getUserPendingBookings = createAsyncThunk<any, getdefaultArgs>(
    "user/getUserPendingBookings",
    async ({ callback }, { rejectWithValue }) => {
        try {
            const response = await ApiBuilder.getUserPendingBookings();
            if (callback) {
                callback(response)
            }
            return response;
        } catch (error) {
            const errorMessage =
                error?.error || error?.response?.data?.message || error?.message || "Some thing went wrong!";
            return rejectWithValue(errorMessage);
        }
    }
);

export const writeReview = createAsyncThunk<any, writeReviewProps>(
    "user/review/writeReview",
    async ({ data, callback }, { rejectWithValue }) => {
        try {
            const response = await ApiBuilder.writeReview(data);
            if (callback) {
                callback(response)
            }
            return response;
        } catch (error) {
            const errorMessage =
                error?.error || error?.response?.data?.message || error?.message || "Some thing went wrong!";
            return rejectWithValue(errorMessage);
        }
    }
);

export const wishlist = createAsyncThunk<any, wishlistProps>(
    "user/wishlist/toggle",
    async ({ data, callback }, { rejectWithValue }) => {
        try {
            const response = await ApiBuilder.wishlist(data);
            if (callback) {
                callback(response)
            }
            return response;
        } catch (error) {
            const errorMessage =
                error?.error || error?.response?.data?.message || error?.message || "Some thing went wrong!";
            return rejectWithValue(errorMessage);
        }
    }
);


export const getAllReview = createAsyncThunk<any, ReviewsArgs>(
    "user/review/getAllReview",
    async ({pathparams='', queryParams,page, callback }, { rejectWithValue }) => {
        try {
            const response = await ApiBuilder.getAllReviews(pathparams,queryParams);
            if (callback) {
                callback(response)
            }
            return response;
        } catch (error) {
            const errorMessage =
                error?.error || error?.response?.data?.message || error?.message || "Some thing went wrong!";
            return rejectWithValue(errorMessage);
        }
    }
);


export const getMyBookingById = createAsyncThunk<any, getBoookingArgs>(
    "user/getMyBookingById",
    async ({pathparams,callback }, { rejectWithValue }) => {
        try {
            const response = await ApiBuilder.getMyBookingById(pathparams);
            if (callback) {
                callback(response)
            }
            return response;
        } catch (error:any) {
            const errorMessage =
                error?.error || error?.response?.data?.message || error?.message || "Booking Details fetch failed";
            return rejectWithValue(errorMessage);
        }
    }
);








